// extracted by mini-css-extract-plugin
export default {"orderRow":"orderRow_orderRow__3uaMJ"};